import * as Sentry from "@sentry/react";

/**
 * Sentry for the desktop client — direct HTTP transport.
 *
 * WHY NOT use tauri-plugin-sentry-api's `makeRendererTransport`?
 * That transport sends envelopes to the Rust process via Tauri IPC.
 * If the FIRST IPC call fails (timing, plugin not ready, permissions),
 * it sets an internal `ipcFailed = true` flag and silently drops ALL
 * subsequent events forever — returning `{ statusCode: 200 }` so the
 * SDK thinks everything is fine. Zero events reach Sentry. This is
 * exactly what happened in production.
 *
 * The fix: use the real DSN with the default browser fetch transport.
 * Events go straight from the JS renderer to Sentry's ingest endpoint.
 * The Rust-side Sentry SDK (`sentry = "0.42"` in Cargo.toml) independently
 * captures native panics and minidumps — those two pipelines don't need
 * to share a transport.
 */
const SENTRY_DSN =
	"https://24d13de54ac7f2671c87340d514bfa5e@o4509714066571264.ingest.us.sentry.io/4511187155681280";

export function initSentry() {
	Sentry.init({
		dsn: SENTRY_DSN,
		sendDefaultPii: true,
		environment: (window as any).__TAURI__ ? "desktop" : "browser",
		// Default transport = fetch — no IPC, no silent drops
		// Filter out BrowserSession — we track app sessions via Rust SDK
		integrations: (integrations) =>
			integrations.filter((i) => i.name !== "BrowserSession"),
	});
}

export function setSentryUser(userId: string, orgId: string) {
	Sentry.setUser({ id: userId, org_id: orgId });
}

export function setSentryInstance(url: string, env: string) {
	Sentry.setTag("instance", url);
	Sentry.setTag("instance_env", env);
}

export { Sentry };
